// extracted by mini-css-extract-plugin
module.exports = {"pressMaterial":"PressMaterial_pressMaterial__nE_Aj","container":"PressMaterial_container__YjACk","item":"PressMaterial_item__i_Rim","grid":"PressMaterial_grid__fBDAJ"};